import '../prototypeExtensions/String'

export const t_element_synced_info = Lang.langGet('Element is published.')
export const t_element_partsynced_info = Lang.langGet('Element not synced to all screens.')
export const t_element_updating_info = Lang.langGet('Element updating.')
export const t_element_tobesynced_info = Lang.langGet('Element can be published.')
export const t_element_error_info = Lang.langGet('Element can not be published, because either approval is missing, or no screens and/or screengroups are assigned.')
export const t_element_tobedeleted_info = Lang.langGet('Element will be deleted.')
export const t_element_empty_info = Lang.langGet('Empty')
export const t_layer = Lang.langGet('Layer').capitalize()
export const t_element = Lang.langGet('Element').capitalize()
export const t_date_time_not_set = Lang.langGet('Date and/or time not set!')
export const t_esign = Lang.langGet('eSign')
export const t_url_not_set = Lang.langGet('URL not set!')
export const t_layer_not_set = Lang.langGet('Layer not set!')
